import { render, staticRenderFns } from "./MySelectCard.vue?vue&type=template&id=b2f3ddf8&scoped=true&"
import script from "./MySelectCard.vue?vue&type=script&lang=js&"
export * from "./MySelectCard.vue?vue&type=script&lang=js&"
import style0 from "./MySelectCard.vue?vue&type=style&index=0&id=b2f3ddf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f3ddf8",
  null
  
)

export default component.exports